import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';

export const Footer = () => {
  return (
    <footer style={{ background: '#000000', borderTop: '1px solid rgba(255, 255, 255, 0.25)', padding: '60px 7.6923%' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '40px' }}>
          {/* Company Info */}
          <div>
            <h3 style={{ fontSize: '24px', fontWeight: '600', color: '#00FFD1', marginBottom: '20px' }}>
              NEXEN DIGITAL
            </h3>
            <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', lineHeight: '1.5', marginBottom: '20px' }}>
              AI-First Development Agency delivering exceptional digital solutions.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="#" style={{ color: '#FFFFFF', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                <Linkedin size={24} />
              </a>
              <a href="#" style={{ color: '#FFFFFF', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                <Twitter size={24} />
              </a>
              <a href="#" style={{ color: '#FFFFFF', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                <Github size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#FFFFFF', marginBottom: '20px' }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/about" style={{ fontSize: '16px', color: '#FFFFFF', textDecoration: 'none', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                About Us
              </Link>
              <Link to="/services" style={{ fontSize: '16px', color: '#FFFFFF', textDecoration: 'none', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                Our Services
              </Link>
              <Link to="/portfolio" style={{ fontSize: '16px', color: '#FFFFFF', textDecoration: 'none', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                Portfolio
              </Link>
              <Link to="/career" style={{ fontSize: '16px', color: '#FFFFFF', textDecoration: 'none', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#FFFFFF'}>
                Career
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#FFFFFF', marginBottom: '20px' }}>
              Contact Us
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <MapPin size={20} style={{ color: '#00FFD1', marginTop: '2px', flexShrink: 0 }} />
                <span style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)' }}>
                  Bhubaneswar, India
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Mail size={20} style={{ color: '#00FFD1', flexShrink: 0 }} />
                <a href="mailto:hello@nexendigital.com" style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', textDecoration: 'none' }}>
                  hello@nexendigital.com
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Phone size={20} style={{ color: '#00FFD1', flexShrink: 0 }} />
                <a href="tel:+919556898310" style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', textDecoration: 'none' }}>
                  +91-9556898310
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ paddingTop: '30px', borderTop: '1px solid rgba(255, 255, 255, 0.25)', textAlign: 'center' }}>
          <p style={{ fontSize: '16px', color: '#FFFFFF' }}>
            © 2025 NEXEN DIGITAL. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};